<div class="splash-container" [class.fade-out]="isClosing" (click)="skipSplash()">
  <div class="splash-content">
    <!-- Animated grape bunch logo -->
    <div class="grape-bunch">
      <img src="/icons/logo-cropped.svg" alt="ZGrane Grono" class="grape-logo">
    </div>
    
    <!-- Small text above company name -->
    <p class="location-text" [class.show]="showTitle">Miasto ZIELONA GÓRA</p>

    <p class="application-text" [class.show]="showTitle">Aplikacja mobilna</p>
    
    <!-- Company name -->
    <h1 class="company-name" [class.show]="showTitle">ZGRANE GRONO</h1>
    
    <!-- Small text below company name -->
    <p class="program-text" [class.show]="showTitle">PROGRAM PARTNERSKI</p>
    
    <!-- Loading message when skipped early -->
    <p class="loading-message" [class.show]="showSkippedLoading">
      Ładowanie danych...
    </p>
 
    <!-- Loading indicator -->
    <div class="loading-dots" [class.show]="showLoading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</div>
